import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { User } from '../../types/User';
import authApi from '../../api/login';
import { AuthState } from '../../types/Auth';

let initialState: AuthState = { user: null, token: null };

try {
    initialState = {
        user: localStorage.getItem('user')
            ? JSON.parse(localStorage.getItem('user') as string)
            : null,
        token: localStorage.getItem('token') || null,
    };
} catch (err) {}

const authSlice = createSlice({
    name: 'auth',
    initialState,
    reducers: {
        login: (
            state,
            action: PayloadAction<{ user: User; token: string }>
        ) => {
            state.user = action.payload.user;
            state.token = action.payload.token;
            localStorage.setItem('token', action.payload.token);
            localStorage.setItem('user', JSON.stringify(action.payload.user));
        },
        logout: (state) => {
            state.user = null;
            state.token = null;
            localStorage.removeItem('token');
            localStorage.removeItem('user');
        },
    },
    extraReducers: (builder) => {
        builder.addMatcher(
            authApi.endpoints.login.matchFulfilled,
            (state, { payload }) => {
                state.user = payload.user;
                state.token = payload.token;
                localStorage.setItem('token', payload.token);
                localStorage.setItem('user', JSON.stringify(payload.user));
            }
        );
    },
});

export const { login, logout } = authSlice.actions;
export default authSlice.reducer;
